import { render, staticRenderFns } from "./task_video.vue?vue&type=template&id=589b242f&scoped=true"
import script from "./task_video.vue?vue&type=script&lang=js"
export * from "./task_video.vue?vue&type=script&lang=js"
import style0 from "./task_video.vue?vue&type=style&index=0&id=589b242f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b242f",
  null
  
)

export default component.exports